import { render, staticRenderFns } from "./BigTop.vue?vue&type=template&id=5bc1580c&scoped=true"
import script from "./BigTop.vue?vue&type=script&lang=ts"
export * from "./BigTop.vue?vue&type=script&lang=ts"
import style0 from "./BigTop.vue?vue&type=style&index=0&id=5bc1580c&prod&lang=css"
import style1 from "./BigTop.vue?vue&type=style&index=1&id=5bc1580c&prod&scoped=true&lang=sass"
import style2 from "./BigTop.vue?vue&type=style&index=2&id=5bc1580c&prod&scoped=true&lang=sass"
import style3 from "./BigTop.vue?vue&type=style&index=3&id=5bc1580c&prod&lang=css"
import style4 from "./BigTop.vue?vue&type=style&index=4&id=5bc1580c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1580c",
  null
  
)

export default component.exports